/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostUsersProfileInvoiceMutationRequest, PostUsersProfileInvoiceMutationResponse, PostUsersProfileInvoice400 } from "../entities/PostUsersProfileInvoice";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { postUsersProfileInvoice } from "../api/postUsersProfileInvoice";
import { useMutation } from "@tanstack/react-query";

export const postUsersProfileInvoiceMutationKey = () => [{ url: '/users/profile/invoice' }] as const

export type PostUsersProfileInvoiceMutationKey = ReturnType<typeof postUsersProfileInvoiceMutationKey>

/**
 * @description Генерация счета
 * @summary Генерация счета
 * {@link /users/profile/invoice}
 */
export function usePostUsersProfileInvoice<TContext>(options: 
{
  mutation?: UseMutationOptions<PostUsersProfileInvoiceMutationResponse, ResponseErrorConfig<PostUsersProfileInvoice400>, {data?: PostUsersProfileInvoiceMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PostUsersProfileInvoiceMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postUsersProfileInvoiceMutationKey()

  return useMutation<PostUsersProfileInvoiceMutationResponse, ResponseErrorConfig<PostUsersProfileInvoice400>, {data?: PostUsersProfileInvoiceMutationRequest}, TContext>({
    mutationFn: async({ data }) => {
      return postUsersProfileInvoice(data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}